<template>
    <div
        style="
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 3mm;
    "
    >
        <tiss-box
            title="GUIA DE RESUMO DE INTERNAÇÃO"
            :guiaPrestador="numeroGuia"
            :logo="logoURL"
            :operadora="logoText"
            v-if="internacao != null"
        >
            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="1 - Registro ANS"
                    largura="10%"
                    :value="registroANS"
                />
                <tiss-field
                    title="3 - Número da Guia de Solicitação de Internação"
                    largura="25%"
                    :value="numeroGuiaSolicitacaoInternacao"
                />
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="4 - Data da Autorização"
                    largura="15%"
                    :value="dataAutorizacao"
                />
                <tiss-field title="5 - Senha" largura="40%" :value="senha" />
                <tiss-field
                    title="6 - Validade da Senha"
                    largura="15%"
                    :value="dataValidadeAutorizacao"
                />
                <tiss-field
                    title="7 - Número da Guia na Operadora"
                    largura="25%"
                    :value="numeroGuiaOperadora"
                />
            </div>

            <div class="row">
                <div class="col">
                    <tiss-sub-title
                        title="Dados do Beneficiário"
                    ></tiss-sub-title>
                </div>
            </div>
            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="8 - Numero da Carteira"
                    largura="31%"
                    :value="numeroCarteira"
                ></tiss-field>
                <tiss-field
                    title="9 - Validade da Carteira"
                    largura="14.7%"
                    :value="validadeCarteira"
                ></tiss-field>
                <tiss-field
                    title="66 - Nome Social"
                    largura="50%"
                    :value="nomeSocialBeneficario"
                ></tiss-field>
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="10 - Nome"
                    largura="50%"
                    :value="nomeBeneficario"
                ></tiss-field>
                <tiss-field
                    title="12 - Atendimento a RN"
                    largura="15%"
                    :value="atendimentoRN"
                ></tiss-field>
            </div>

            <div class="row">
                <div class="col">
                    <tiss-sub-title
                        title="Dados do Contratado Executante"
                    ></tiss-sub-title>
                </div>
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="13 - Código na Operadora "
                    largura="25%"
                    :value="codigoPrestadorNaOperadoraExecutante"
                />
                <tiss-field
                    title="14 - Nome do Contratado"
                    largura="52%"
                    :value="nomeContratadoExecutante"
                />
                <tiss-field
                    title="15 - Código CNES"
                    largura="18.6%"
                    :value="cnes"
                />
            </div>

            <div class="row">
                <div class="col">
                    <tiss-sub-title
                        title="Dados da Internação"
                    ></tiss-sub-title>
                </div>
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="16 - Caráter do Atendimento "
                    largura="12%"
                    :value="caraterAtendimento"
                ></tiss-field>
                <tiss-field
                    title="17 - Tipo de Faturamento"
                    largura="11%"
                    :value="tipoFaturamento"
                ></tiss-field>
                <tiss-field
                    title="18 - Data Início Faturamento"
                    largura="12%"
                    :value="dataInicioFaturamento"
                ></tiss-field>
                <tiss-field
                    title="19 - Hora Início Faturamento"
                    largura="12%"
                    :value="horaInicioFaturamento"
                ></tiss-field>
                <tiss-field
                    title="20 - Data Fim Faturamento"
                    largura="12%"
                    :value="dataFinalFaturamento"
                ></tiss-field>
                <tiss-field
                    title="21 - Hora Fim Faturamento"
                    largura="12%"
                    :value="horaFinalFaturamento"
                ></tiss-field>
                <tiss-field
                    title="22 - Tipo Internação"
                    largura="10%"
                    :value="tipoInternacao"
                ></tiss-field>
                <tiss-field
                    title="23- Regime Internação"
                    largura="11%"
                    :value="regimeInternacao"
                ></tiss-field>
                <!-- <tiss-field
                    title="22 - Data da Solicitação"
                    largura="15%"
                    :value="dataSolicitacao"
                ></tiss-field>
                <tiss-field
                    title="23 - Indicação"
                    largura="66.6%"
                    :value="indicacao"
                ></tiss-field> -->
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="24-CID10Principal (Opcional)"
                    largura="15%"
                />
                <tiss-field
                    title="28 - Indicação de Acidente"
                    largura="25%"
                    :value="indicadorAcidente"
                />
                <tiss-field
                    title="29 - Motivo de Encerramento da Internação"
                    largura="25%"
                    :value="motivoEncerramento"
                />
                <tiss-field
                    title="30 - Número da declaração de nascido vivo"
                    largura="30%"
                />
            </div>

            <div class="row">
                <div class="col">
                    <tiss-sub-title
                        title="Procedimentos e Exames Realizados"
                    ></tiss-sub-title>
                </div>
            </div>
            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-table
                    largura="98%"
                    altura="1.8cm"
                    :campos="tabelaProcedimentosExecutados"
                    :numeracao="Number('34')"
                    :sizeCampos="[4, 4, 4, 4, 8, 13, 4, 2, 2, 4, 5, 4]"
                    :indice="true"
                />
            </div>

            <div class="row">
                <div class="col">
                    <tiss-sub-title
                        title="Identificação do(s) Profissional(is) Executante(s)"
                    ></tiss-sub-title>
                </div>
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-table
                    largura="98%"
                    altura="1.8cm"
                    :campos="tabelaProfissionaisExecutantes"
                    :numeracao="46"
                    :sizeCampos="[2, 2, 4, 7, 3, 3, 1, 3]"
                    :indice="true"
                />
            </div>

            <template v-if="1 == 1">
                <div class="row mx-1" style="margin-bottom: 1px;">
                    <tiss-field
                        title="54 - Total Procedimentos"
                        largura="13%"
                        :value="valorProcedimentos"
                    />
                    <tiss-field
                        title="55 - Total Diárias"
                        largura="10%"
                        :value="valorDiarias"
                    />
                    <tiss-field
                        title="56 - Total Taxas e Aluguéis"
                        largura="13%"
                        :value="valorTaxasAlugueis"
                    />
                    <tiss-field
                        title="57 - Total Materiais"
                        largura="10%"
                        :value="valorMateriais"
                    />
                    <tiss-field
                        title="58 - Total OPME"
                        largura="10%"
                        :value="valorOPME"
                    />
                    <tiss-field
                        title="50 - Total Medicamentos"
                        largura="13%"
                        :value="valorMedicamentos"
                    />
                    <tiss-field
                        title="60 - Total Gases Medicinais"
                        largura="13%"
                        :value="valorGasesMedicinais"
                    />
                    <tiss-field
                        title="61 - Total Geral"
                        largura="10.8%"
                        :value="valorGeral"
                    />
                </div>

                <div class="row mx-1 mb-0">
                    <tiss-field
                        title="62 - Data e Assinatura do Responsável pela Autorização"
                        largura="32%"
                    ></tiss-field>
                    <tiss-field
                        title="63 - Data e Assinatura do Beneficiário ou  Responsável"
                        largura="32%"
                    ></tiss-field>
                    <tiss-field
                        title="64 - Data e Assinatura do Contratado"
                        largura="32.6%"
                        :value="nomeContratadoAss"
                    ></tiss-field>
                </div>
            </template>
            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="58 - Observação/Justificativa"
                    largura="98%"
                    altura="1.8cm"
                    :value="observacao"
                    :obrigatorio="false"
                />
            </div>

            <div class="row mx-1">
                <div class="col">
                    <tiss-rodape
                        :infoId="this.guia.id_atendimento"
                        :idExterno="this.guia.st_id_externo"
                        :responsavel="atendimento_usuario()"
                        :pageIndex="pageIndex"
                        :pageCount="pageCount"
                    ></tiss-rodape>
                </div>
            </div>

            <!-- <br /><br /><br /><br /><br /><br />

            <div class="row">
                <div class="col">
                    <tiss-sub-title
                        title="Dados do Solicitante"
                    ></tiss-sub-title>
                </div>
            </div>
            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="13 - Código na Operadora"
                    largura="30%"
                    :value="codigoPrestadorNaOperadora"
                />
                <tiss-field
                    title="14 - Nome do Contratado"
                    largura="67.3%"
                    :value="nomeContratado"
                />
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="15 - Nome do Profissional"
                    largura="30%"
                    :value="nomeProfissional"
                />
                <tiss-field
                    title="16 - Conselho Profissional"
                    largura="14%"
                    :value="numeroConselhoProfissional"
                />
                <tiss-field
                    title="17 - Número do Conselho"
                    largura="15%"
                    :value="conselhoProfissional"
                />
                <tiss-field title="18 - UF" largura="6%" :value="UF" />
                <tiss-field
                    title="19 - Código CBO"
                    largura="10%"
                    :value="cbos"
                />
                <tiss-field
                    title="20 - Assinatura do Profissional Solicitante"
                    largura="19.4%"
                    value
                />
            </div>

            <div class="row">
                <div class="col">
                    <tiss-sub-title
                        title="Dados da Solicitação / Procedimentos e Exames Solicitados"
                    ></tiss-sub-title>
                </div>
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-table
                    largura="98%"
                    altura="1.8cm"
                    :campos="tabelaProcedimentosSolicitados"
                    :numeracao="Number('24')"
                    :sizeCampos="[2, 3, 12, 2, 2]"
                />
            </div>

            <div class="row">
                <div class="col">
                    <tiss-sub-title
                        title="Dados do Atendimento"
                    ></tiss-sub-title>
                </div>
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-field
                    title="32 - Tipo de Atendimento"
                    largura="24%"
                    :value="tipoAtendimento"
                />

                <tiss-field
                    title="34 - Tipo de Consulta"
                    largura="24%"
                    :value="tipoConsulta"
                />
                <tiss-field
                    title="35 - Motivo de Encerramento deo Atendimento"
                    largura="24%"
                />
            </div>

            <div class="row mx-1" style="margin-bottom: 1px;">
                <tiss-assinaturas
                    :title="[
                        '56 - Data de Realização de Procedimentos em Série',
                        '57 - Assinatura do Beneficiario ou Responsavel'
                    ]"
                    largura="98%"
                    altura="1.1cm"
                    :quantidade="10"
                    :colunas="5"
                />
            </div> -->
        </tiss-box>
    </div>
</template>

<script>
import * as moment from "moment";
import TissTable from "./TissTable.vue";
import TissBox from "./TissBox.vue";
import TissField from "./TissField.vue";
import TissSubTitle from "./TissSubTitle.vue";
// import TissAssinaturas from "./TissAssinaturas.vue";
import TissRodape from "./TissRodape";

export default {
    data() {
        return {
            largura: "21cm",
            larguramm: 200
        };
    },
    methods: {
        clargura(perc = 100) {
            let larg = this.larguramm - 20;
            larg = Math.round(larg * (perc / 100));
            return larg + "mm";
        },
        atendimento_usuario() {
            if (this.guia && this.guia.st_login) {
                return this.guia.st_login;
            }

            return null;
        },
        ocultar_valores() {
            return this.guia && this.guia.ocultar_valores;
        }
    },
    computed: {
        nomeContratadoAss: function() {
            if (!this.nome_contratado_ass) {
                return "";
            }

            return this.nomeContratadoExecutante;
        },

        logoURL: function() {
            if (this.guia && this.guia.logo_url_front) {
                return this.guia.logo_url_front;
            }

            if (this.guia && this.guia.logo_text_front) {
                return null;
            }

            return this.logo
        },

        logoText: function() {
            if (this.guia && this.guia.logo_text_front) {
                return this.guia.logo_text_front;
            }

            return this.operadora ? this.operadora.search : '';
        },

        internacao: function() {
            if (this.guia != null && this.guia.mensagemTISS != null) {
                return this.guia.mensagemTISS;
            }
            return null;
        },

        procedimentos: function() {
            let array = [];
            if (
                !Array.isArray(
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.procedimentosExecutados
                        .procedimentoExecutado
                )
            ) {
                array[0] = this.internacao.prestadorParaOperadora.loteGuias.guiasTISS.guiaResumoInternacao.procedimentosExecutados.procedimentoExecutado;
            } else
                array = this.internacao.prestadorParaOperadora.loteGuias
                    .guiasTISS.guiaResumoInternacao.procedimentosExecutados
                    .procedimentoExecutado;
            return array;
        },
        valorPago() {
            let valor = {};
            if (
                Array.isArray(
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.valorTotal
                )
            ) {
                valor = this.internacao.prestadorParaOperadora.loteGuias
                    .guiasTISS.guiaResumoInternacao.valorTotal[0];
            } else
                valor = this.internacao.prestadorParaOperadora.loteGuias
                    .guiasTISS.guiaResumoInternacao.valorTotal;
            return valor;
        },
        registroANS: function() {
            if (
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.cabecalhoGuia &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.cabecalhoGuia.registroANS
            )
                return this.internacao.prestadorParaOperadora.loteGuias
                    .guiasTISS.guiaResumoInternacao.cabecalhoGuia.registroANS;
            else return "";
        },
        numeroGuiaSolicitacaoInternacao: function() {
            if (
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.numeroGuiaSolicitacaoInternacao &&
                !Array.isArray(
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.numeroGuiaSolicitacaoInternacao
                )
            )
                return this.internacao.prestadorParaOperadora.loteGuias
                    .guiasTISS.guiaResumoInternacao
                    .numeroGuiaSolicitacaoInternacao;
            else return "";
        },
        numeroGuia: function() {
            if (
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.cabecalhoGuia &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.cabecalhoGuia.numeroGuiaPrestador
            )
                return this.internacao.prestadorParaOperadora.loteGuias
                    .guiasTISS.guiaResumoInternacao.cabecalhoGuia
                    .numeroGuiaPrestador;
            else return "";
        },
        senha: function() {
            let senha = "";
            if (
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosAutorizacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosAutorizacao.senha
            ) {
                senha = this.internacao.prestadorParaOperadora.loteGuias
                    .guiasTISS.guiaResumoInternacao.dadosAutorizacao.senha;
            }

            // Truncate
            if (senha.length > 30) senha = senha.substring(0, 30) + "...";

            return senha;
        },
        dataAutorizacao: function() {
            let data = "";

            if (
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosAutorizacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosAutorizacao.dataAutorizacao &&
                !Array.isArray(
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosAutorizacao.dataAutorizacao
                )
            ) {
                data = this.$util.getFormatDate(
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosAutorizacao.dataAutorizacao
                );
            }
            return data;
        },
        dataValidadeAutorizacao: function() {
            let dataValidade = "";

            if (
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosAutorizacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosAutorizacao.dataValidadeSenha &&
                !Array.isArray(
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosAutorizacao.dataValidadeSenha
                )
            ) {
                dataValidade = this.$util.getFormatDate(
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosAutorizacao.dataValidadeSenha
                );
            }
            return dataValidade;
        },
        numeroGuiaOperadora: function() {
            if (this.guia && this.guia.st_numero) {
                return this.guia.st_numero;
            }

            return null;
        },
        numeroCarteira: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosBeneficiario &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosBeneficiario.numeroCarteira
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosBeneficiario.numeroCarteira
                : "";
        },
        validadeCarteira: function() {
            if (this.guia.dt_validade_carteira) {
                return this.$util.getFormatDate(
                    this.guia.dt_validade_carteira,
                    "DD/MM/YYYY"
                );
            }
            return "";
        },
        atendimentoRN: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosBeneficiario &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosBeneficiario.atendimentoRN
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosBeneficiario.atendimentoRN
                : "";
        },
        nomeBeneficario: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosBeneficiario &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosBeneficiario.nomeBeneficiario
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosBeneficiario.nomeBeneficiario
                : "";
        },
        nomeSocialBeneficario: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosBeneficiario &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosBeneficiario
                    .nomeSocialBeneficiario &&
                !Array.isArray(
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosBeneficiario
                        .nomeSocialBeneficiario
                )
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosBeneficiario
                      .nomeSocialBeneficiario
                : "";
        },
        codigoPrestadorNaOperadora: function() {
            let codPrestador = "";
            if (
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante.contratadoSolicitante
            ) {
                if (
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosSolicitante
                        .contratadoSolicitante.cnpjContratado
                ) {
                    codPrestador = this.internacao.prestadorParaOperadora
                        .loteGuias.guiasTISS.guiaResumoInternacao
                        .dadosSolicitante.contratadoSolicitante.cnpjContratado;
                } else if (
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosSolicitante
                        .contratadoSolicitante.cpfContratado
                ) {
                    codPrestador = this.internacao.prestadorParaOperadora
                        .loteGuias.guiasTISS.guiaResumoInternacao
                        .dadosSolicitante.contratadoSolicitante.cpfContratado;
                } else if (
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosSolicitante
                        .contratadoSolicitante.codigoPrestadorNaOperadora
                ) {
                    codPrestador = this.internacao.prestadorParaOperadora
                        .loteGuias.guiasTISS.guiaResumoInternacao
                        .dadosSolicitante.contratadoSolicitante
                        .codigoPrestadorNaOperadora;
                }
            }
            return codPrestador;
        },
        nomeContratado: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosSolicitante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante
                    .contratadoSolicitante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante.contratadoSolicitante
                    .nomeContratado
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosSolicitante
                      .contratadoSolicitante.nomeContratado
                : "";
        },
        nomeProfissional: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosSolicitante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante
                    .profissionalSolicitante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante
                    .profissionalSolicitante.nomeProfissional
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosSolicitante
                      .profissionalSolicitante.nomeProfissional
                : "";
        },
        numeroConselhoProfissional: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosSolicitante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante
                    .profissionalSolicitante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante
                    .profissionalSolicitante.conselhoProfissional
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosSolicitante
                      .profissionalSolicitante.conselhoProfissional
                : "";
        },
        conselhoProfissional: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosSolicitante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante
                    .profissionalSolicitante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante
                    .profissionalSolicitante.numeroConselhoProfissional
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosSolicitante
                      .profissionalSolicitante.numeroConselhoProfissional
                : "";
        },
        UF: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosSolicitante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante
                    .profissionalSolicitante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante
                    .profissionalSolicitante.UF
                ? this.$util.siglaUF(
                      this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaResumoInternacao.dadosSolicitante
                          .profissionalSolicitante.UF
                  )
                : "";
        },

        cbos: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosSolicitante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante
                    .profissionalSolicitante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitante
                    .profissionalSolicitante.CBOS
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosSolicitante
                      .profissionalSolicitante.CBOS
                : "";
        },

        dataSolicitacao: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosSolicitacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitacao.dataSolicitacao
                ? this.$util.getFormatDate(
                      this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaResumoInternacao.dadosSolicitacao
                          .dataSolicitacao,
                      "DD/MM/YYYY"
                  )
                : "";
        },
        caraterAtendimento: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosInternacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosInternacao.caraterAtendimento
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosInternacao.caraterAtendimento
                : "";
        },
        tipoFaturamento: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosInternacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosInternacao.tipoFaturamento
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosInternacao.tipoFaturamento
                : "";
        },
        dataInicioFaturamento: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosInternacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosInternacao.dataInicioFaturamento
                ? this.$util.getFormatDate(
                      this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaResumoInternacao.dadosInternacao
                          .dataInicioFaturamento,
                      "DD/MM/YYYY"
                  )
                : "";
        },
        horaInicioFaturamento: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosInternacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosInternacao.horaInicioFaturamento
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosInternacao
                      .horaInicioFaturamento
                : "";
        },
        dataFinalFaturamento: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosInternacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosInternacao.dataFinalFaturamento
                ? this.$util.getFormatDate(
                      this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaResumoInternacao.dadosInternacao
                          .dataFinalFaturamento,
                      "DD/MM/YYYY"
                  )
                : "";
        },
        horaFinalFaturamento: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosInternacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosInternacao.horaFinalFaturamento
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosInternacao.horaFinalFaturamento
                : "";
        },
        tipoInternacao: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosInternacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosInternacao.tipoInternacao
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosInternacao.tipoInternacao
                : "";
        },
        regimeInternacao: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosInternacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosInternacao.regimeInternacao
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosInternacao.regimeInternacao
                : "";
        },

        indicacao: function() {
            if (
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSolicitacao.indicacaoClinica
            )
                return this.internacao.prestadorParaOperadora.loteGuias
                    .guiasTISS.guiaResumoInternacao.dadosSolicitacao
                    .indicacaoClinica;
            return "";
        },

        codigoPrestadorNaOperadoraExecutante: function() {
            let txt = "";
            if (
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosExecutante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosExecutante.contratadoExecutante
            ) {
                if (
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosExecutante
                        .contratadoExecutante.cnpjContratado
                )
                    txt = this.internacao.prestadorParaOperadora.loteGuias
                        .guiasTISS.guiaResumoInternacao.dadosExecutante
                        .contratadoExecutante.cnpjContratado;
                else if (
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosExecutante
                        .contratadoExecutante.codigoPrestadorNaOperadora
                ) {
                    txt = this.internacao.prestadorParaOperadora.loteGuias
                        .guiasTISS.guiaResumoInternacao.dadosExecutante
                        .contratadoExecutante.codigoPrestadorNaOperadora;
                } else if (
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosExecutante
                        .contratadoExecutante.cpfContratado
                ) {
                    txt = this.internacao.prestadorParaOperadora.loteGuias
                        .guiasTISS.guiaResumoInternacao.dadosExecutante
                        .contratadoExecutante.cpfContratado;
                } else if (
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosExecutante
                        .contratadoExecutante.cpfContratado
                ) {
                    txt = this.internacao.prestadorParaOperadora.loteGuias
                        .guiasTISS.guiaResumoInternacao.dadosExecutante
                        .contratadoExecutante.cpfContratado;
                }
            }
            return txt;
        },
        nomeContratadoExecutante: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosExecutante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosExecutante
                    .contratadoExecutante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosExecutante.contratadoExecutante
                    .nomeContratado
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosExecutante.contratadoExecutante
                      .nomeContratado
                : "";
        },
        cnes: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosExecutante &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosExecutante.CNES &&
                !Array.isArray(
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosExecutante.CNES
                )
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosExecutante.CNES
                : "";
        },
        dataExecução: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.procedimentosExecutados &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.procedimentosExecutados
                    .procedimentoExecutado &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.procedimentosExecutados
                    .procedimentoExecutado.dataExecução
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.procedimentosExecutados
                      .procedimentoExecutado.dataExecução
                : "";
        },
        indicadorAcidente: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosSaidaInternacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSaidaInternacao.indicadorAcidente
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosSaidaInternacao
                      .indicadorAcidente
                : "";
        },
        motivoEncerramento: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosSaidaInternacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosSaidaInternacao
                    .motivoEncerramento
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosSaidaInternacao
                      .motivoEncerramento
                : "";
        },
        tipoConsulta: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosAtendimento &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosAtendimento.tipoConsulta &&
                !Array.isArray(
                    this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                        .guiaResumoInternacao.dadosAtendimento.tipoConsulta
                )
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosAtendimento.tipoConsulta
                : "";
        },
        tipoAtendimento: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao.dadosAtendimento &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.dadosAtendimento.tipoAtendimento
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.dadosAtendimento.tipoAtendimento
                : "";
        },

        valorProcedimentos: function() {
            return !this.ocultar_valores() &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal.valorProcedimentos
                ? this.$util.formatMoeda(
                      this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaResumoInternacao.valorTotal.valorProcedimentos
                  )
                : "";
        },
        valorDiarias: function() {
            return !this.ocultar_valores() &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal.valorDiarias
                ? this.$util.formatMoeda(
                      this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaResumoInternacao.valorTotal.valorDiarias
                  )
                : "";
        },
        valorTaxasAlugueis: function() {
            return !this.ocultar_valores() &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal.valorTaxasAlugueis
                ? this.$util.formatMoeda(
                      this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaResumoInternacao.valorTotal.valorTaxasAlugueis
                  )
                : "";
        },
        valorMateriais: function() {
            return !this.ocultar_valores() &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal.valorMateriais
                ? this.$util.formatMoeda(
                      this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaResumoInternacao.valorTotal.valorMateriais
                  )
                : "";
        },
        valorMedicamentos: function() {
            return !this.ocultar_valores() &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal.valorMedicamentos
                ? this.$util.formatMoeda(
                      this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaResumoInternacao.valorTotal.valorMedicamentos
                  )
                : "";
        },
        valorOPME: function() {
            return !this.ocultar_valores() &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal.valorOPME
                ? this.$util.formatMoeda(
                      this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaResumoInternacao.valorTotal.valorOPME
                  )
                : "";
        },
        valorGasesMedicinais: function() {
            return !this.ocultar_valores() &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal.valorGasesMedicinais
                ? this.$util.formatMoeda(
                      this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaResumoInternacao.valorTotal.valorGasesMedicinais
                  )
                : "";
        },
        valorGeral: function() {
            return !this.ocultar_valores() &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.valorTotal.valorTotalGeral
                ? this.$util.formatMoeda(
                      this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                          .guiaResumoInternacao.valorTotal.valorTotalGeral
                  )
                : "";
        },
        tabelaProcedimentosSolicitados: function() {
            let campos = [];
            let procedimentos = this.procedimentos;

            for (let i = 0; i < procedimentos.length; i++) {
                if (procedimentos[i] && procedimentos[i].esconder) {
                    continue;
                }

                let tmp = {};

                if (!procedimentos[i]) {
                    continue;
                }

                if (
                    procedimentos[i].procedimento &&
                    procedimentos[i].procedimento.codigoTabela
                ) {
                    tmp["Tabela"] = procedimentos[i].procedimento.codigoTabela;
                } else tmp["Tabela"] = "";

                if (procedimentos[i].procedimento.codigoProcedimento)
                    tmp["Codigo do Procedimento"] =
                        procedimentos[i].procedimento.codigoProcedimento;
                else tmp["Codigo do Procedimento"] = "";

                if (
                    procedimentos[i].procedimento &&
                    procedimentos[i].procedimento.descricaoProcedimento
                )
                    tmp["Descrição"] =
                        procedimentos[i].procedimento.descricaoProcedimento;
                else tmp["Descrição"] = "";

                if (procedimentos[i].quantidadeExecutada) {
                    tmp["Qt. Solic."] = procedimentos[i].quantidadeExecutada;
                } else tmp["Qt. Solic."] = "";

                if (procedimentos[i].quantidadeExecutada) {
                    tmp["Qt. Autor."] = procedimentos[i].quantidadeExecutada;
                } else tmp["Qt. Autor."] = "";

                campos.push(tmp);
            }

            return campos;
        },
        tabelaProcedimentosExecutados: function() {
            let campos = [];
            // let procedimentos = this.internacao.prestadorParaOperadora.loteGuias
            //   .guiasTISS.guiaResumoInternacao.procedimentosExecutados.procedimentoExecutado;
            let procedimentos = this.procedimentos;
            for (let i = 0; i < procedimentos.length; i++) {
                let tmp = {};

                if (!procedimentos[i]) continue;

                if (procedimentos[i].dataExecucao) {
                    tmp["Data"] = this.$util.getFormatDate(
                        procedimentos[i].dataExecucao,
                        "DD/MM/YYYY"
                    );
                } else tmp["Data"] = "";

                if (procedimentos[i].horaInicial)
                    tmp["Hora Inicial"] = moment(
                        procedimentos[i].horaInicial,
                        "HH:mm:ss"
                    ).format("HH:mm");
                else tmp["Hora Inicial"] = "";

                if (procedimentos[i].horaFinal)
                    tmp["Hora Final"] = moment(
                        procedimentos[i].horaFinal,
                        "HH:mm:ss"
                    ).format("HH:mm");
                else tmp["Hora Final"] = "";

                if (
                    procedimentos[i].procedimento &&
                    procedimentos[i].procedimento.codigoTabela
                )
                    tmp["Tabela"] = procedimentos[i].procedimento.codigoTabela;
                else tmp["Tabela"] = "";

                if (procedimentos[i].procedimento.codigoProcedimento)
                    tmp["Codigo do Procedimento"] =
                        procedimentos[i].procedimento.codigoProcedimento;
                else tmp["Codigo do Procedimento"] = "";

                if (
                    procedimentos[i].procedimento &&
                    procedimentos[i].procedimento.descricaoProcedimento
                )
                    tmp["Descrição"] =
                        procedimentos[i].procedimento.descricaoProcedimento;
                else tmp["Descrição"] = "";

                if (procedimentos[i] && procedimentos[i].quantidadeExecutada)
                    tmp["Quantidade"] = procedimentos[i].quantidadeExecutada;
                else tmp["Quantidade"] = "";

                if (procedimentos[i].viaAcesso)
                    tmp["Via"] = procedimentos[i].viaAcesso;
                else tmp["Via"] = "";

                if (procedimentos[i].tecnicaUtilizada)
                    tmp["Tec."] = procedimentos[i].tecnicaUtilizada;
                else tmp["Tec."] = "";

                if (procedimentos[i].reducaoAcrescimo)
                    tmp["%Red./Acresc."] = this.$util.formatMoeda(
                        procedimentos[i].reducaoAcrescimo
                    );
                else tmp["%Red./Acresc."] = "";

                if (procedimentos[i].valorUnitario)
                    tmp["Valor Unitario"] = !this.ocultar_valores()
                        ? this.$util.formatMoeda(procedimentos[i].valorUnitario)
                        : "";
                else tmp["Valor Unitario"] = "";

                if (procedimentos[i].valorTotal)
                    tmp["Valor Total"] = !this.ocultar_valores()
                        ? this.$util.formatMoeda(procedimentos[i].valorTotal)
                        : "";
                else tmp["Valor Total"] = "";

                campos.push(tmp);
            }

            return campos;
        },
        tabelaProfissionaisExecutantes: function() {
            let campos = [];
            // let procedimentos = this.internacao.prestadorParaOperadora.loteGuias
            //   .guiasTISS.guiaResumoInternacao.procedimentosExecutados.procedimentoExecutado;
            let procedimentos = this.procedimentos;

            for (var i = 0; i < procedimentos.length; i++) {
                if (!procedimentos[i]) continue;

                let iEquipe = [];
                if (Array.isArray(procedimentos[i].identEquipe)) {
                    iEquipe = procedimentos[i].identEquipe;
                } else {
                    iEquipe = [procedimentos[i].identEquipe];
                }

                for(let j = 0; j < iEquipe.length; j++) {

                    let tmp = {};
                    tmp["Seq. Ref."] = "";

                    if (iEquipe[j].identificacaoEquipe.grauPart) {
                        tmp["Grau Part."] =
                            iEquipe[j].identificacaoEquipe.grauPart;
                    } else tmp["Grau Part."] = "";

                    if (
                        iEquipe[j].identificacaoEquipe.codProfissional
                            .cpfContratado
                    ) {
                        tmp["Código na Operadora/CPF"] =
                            iEquipe[j].identificacaoEquipe.codProfissional.cpfContratado;
                    } else if (
                        iEquipe[j].identificacaoEquipe.codProfissional
                            .codigoPrestadorNaOperadora
                    ) {
                        tmp["Código na Operadora/CPF"] =
                            iEquipe[j].identificacaoEquipe.codProfissional.codigoPrestadorNaOperadora;
                    } else tmp["Código na Operadora/CPF"] = "";

                    if (iEquipe[j].identificacaoEquipe.nomeProf)
                        tmp["Nome do Profissional"] =
                            iEquipe[j].identificacaoEquipe.nomeProf;
                    else tmp["Nome do Profissional"] = "";

                    if (iEquipe[j].identificacaoEquipe.conselho)
                        tmp["Conselho Profissional"] =
                            iEquipe[j].identificacaoEquipe.conselho;
                    else tmp["Conselho Profissional"] = "";

                    if (
                        iEquipe[j].identificacaoEquipe
                            .numeroConselhoProfissional
                    )
                        tmp["Número no Conselho"] =
                                iEquipe[j].identificacaoEquipe.numeroConselhoProfissional;
                    else tmp["Número no Conselho"] = "";

                    if (
                        iEquipe[j].identificacaoEquipe &&
                        iEquipe[j].identificacaoEquipe.UF
                    )
                        tmp["UF"] = this.$util.siglaUF(
                            iEquipe[j].identificacaoEquipe.UF
                        );
                    else tmp["UF"] = "";

                    if (
                        iEquipe[j].identificacaoEquipe &&
                        iEquipe[j].identificacaoEquipe.CBOS
                    )
                        tmp["Código CBO"] =
                            iEquipe[j].identificacaoEquipe.CBOS;
                    else tmp["Código CBO"] = "";

                    campos.push(tmp);
                }
            }

            return campos;
        },

        observacao: function() {
            return this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                .guiaResumoInternacao &&
                this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                    .guiaResumoInternacao.observacao
                ? this.internacao.prestadorParaOperadora.loteGuias.guiasTISS
                      .guiaResumoInternacao.observacao
                : "";
        },

        styleRotate() {
            if (this.rotate)
                return "transform: rotate(270deg) translate(-376mm, 0); transform-origin: 0 0; margin: 0; padding: 0;";
            //return "-webkit-transform: rotate(-90deg) !important;-moz-transform:rotate(-90deg) !important;-o-transform: rotate(-90deg) !important; -ms-transform:rotate(-90deg) !important;position:relative;top:15cm;left:0px; padding:1cm;";
            //return "-webkit-transform: rotate(-90deg) scale(.65,.65) !important;-moz-transform:rotate(-90deg) scale(.58,.58)!important;-o-transform: rotate(-90deg) scale(.58,.58)!important; -ms-transform:rotate(-90deg) scale(.6,.6)!important;position:relative;top:10cm;left:0px; padding:1cm;";
            return "";
        }
    },
    props: ["guia", "logo", "operadora", "rotate", "nome_contratado_ass", "pageIndex", "pageCount"],
    components: {
        TissTable,
        TissBox,
        TissField,
        TissSubTitle,
        // TissAssinaturas,
        TissRodape
    }
};
</script>

<style></style>